import { render, staticRenderFns } from "./beginList.vue?vue&type=template&id=4703256a&scoped=true"
import script from "./beginList.vue?vue&type=script&lang=js"
export * from "./beginList.vue?vue&type=script&lang=js"
import style0 from "./beginList.vue?vue&type=style&index=0&id=4703256a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4703256a",
  null
  
)

export default component.exports